/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDevise } from '../../models/api-response-devise';
import { Devise } from '../../models/devise';

export interface UpdateDevise$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: Devise
}

export function updateDevise(http: HttpClient, rootUrl: string, params: UpdateDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
  const rb = new RequestBuilder(rootUrl, updateDevise.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDevise>;
    })
  );
}

updateDevise.PATH = '/v1/api/ui/devise/{ref}';
